import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  NavbarDropdownToggle,
} from "../navbarComponents";
import StockInputCreate from "./StockInputCreate";
import StockClear from "./StockClear";
import StockRegulate from "./StockRegulate";

const StockMaterialsNavbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpened, setModalOpened] = useState("closed");

  const closeModal = () => {
    setModalOpened("closed");
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <React.Fragment>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <NavbarDropdownToggle color="info" caret>
          Opções de Estoque
        </NavbarDropdownToggle>

        <DropdownMenu>
          <DropdownItem onClick={() => setModalOpened("entry")}>
            Entrada de Estoque
          </DropdownItem>
          <DropdownItem onClick={() => setModalOpened("clean")}>
            Limpar Estoque
          </DropdownItem>
          <DropdownItem onClick={() => setModalOpened("regularize")}>
            Regularizar Estoque
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {modalOpened === "entry" && (
        <StockInputCreate isOpen={modalOpened === "entry"} toggleModal={closeModal} />
      )}

      {modalOpened === "clean" && (
        <StockClear isOpen={modalOpened === "clean"} toggleModal={closeModal} />
      )}

      {modalOpened === "regularize" && (
        <StockRegulate isOpen={modalOpened === "regularize"} toggleModal={closeModal} />
      )}
    </React.Fragment>
  );
};

export default StockMaterialsNavbar;
